<template>
  <div>
    <v-card class="mx-auto pa-2" max-width="100%" elevation="1" outlined>
      <v-container fluid no-gutters>
        <v-row>
          <v-col align="center" no-gutters>
            <h4>
              <div class="graph-title">{{ heading }}</div>
            </h4>
            <v-btn
              fab
              absolute
              top
              right
              x-small
              elevation="1"
              @click="fullscreen"
            >
              <v-icon>mdi-fullscreen</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row pa-0 ma-0 v-if="!fullscreenFlag">
          <v-checkbox
            v-model="typeStack"
            :disabled="
              postType == 'Social' || postType == 'Sports' || sportStack == true
            "
            class="mx-2"
            color="primary"
            label="Type Stacked View"
            @change="emitBaseChange"
          ></v-checkbox>
          <v-checkbox
            v-model="sportStack"
            :disabled="typeStack"
            class="mx-2"
            color="primary"
            label="Sports Stacked View"
            @change="emitBaseChange"
          ></v-checkbox>
          <v-col md="3" v-if="typeStack == false && sportStack == false">
            <v-select
              solo
              filled
              v-model="postType"
              :items="['All', 'Sports', 'Social']"
              @change="emitBaseChange"
              label="Type"
            >
            </v-select>
          </v-col>
          <v-col md="3" v-if="sportStack == true">
            <v-select
              solo
              filled
              multiple
              :items="interestSports"
              @change="emitBaseChange"
              v-model="sports"
              item-value="id"
              item-text="name"
              label="Sports"
            >
              <template
                v-if="interestSports.length == sports.length"
                v-slot:selection="{ index }"
              >
                <span v-if="index == 0">All Sports</span>
              </template>
              <template v-else v-slot:selection="{ item, index }">
                <span v-if="index == 0">{{ item.name }}</span>
                <span v-if="index === 1" class="grey--text caption pl-1">
                  and {{ sports.length - 1 }} others</span
                >
              </template>
            </v-select>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </v-container>

      <column-chart
        :data="chartData"
        :dataset="{ borderWidth: 2 }"
        :colors="colors"
        :ytitle="yTitle"
        :xtitle="xTitle"
        :stacked="true"
        :library="chartOptions"
        legend="bottom"
      ></column-chart>
    </v-card>
    <v-dialog v-model="dialog" max-width="90%" @input="closeEvent">
      <div v-if="fullscreenFlag">
        <v-card class="mx-auto pa-2" max-width="100%" elevation="1" outlined>
          <v-container fluid no-gutters>
            <v-row>
              <v-col align="center" no-gutters>
                <h4>
                  <div class="graph-title">{{ heading }}</div>
                </h4>
              </v-col>
            </v-row>
            <v-row no-gutters pa-0 ma-0>
              <v-col align="left" cols="2" md="2" no-gutters>
                <v-btn-toggle
                  dense
                  borderless
                  color="rgb(102, 200, 200)"
                  class="date_button_navigation"
                  v-model="toggle_mode"
                  @change="changeMode"
                  mandatory
                >
                  <v-btn value="day">Day</v-btn>
                  <v-btn value="month">Month</v-btn>
                  <v-btn value="year">Year</v-btn>
                </v-btn-toggle>
              </v-col>
              <v-col align="center" cols="3" md="3">
                <v-row no-gutters pa-0 ma-0>
                  <v-spacer></v-spacer>
                  <!----------Column 1 Start    ----------------  -->
                  <v-col align="center" cols="10" md="10" v-if="dayClick">
                    <div class="pickers mr-4">
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-menu
                            v-model="dateMenu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                solo
                                dense
                                class="text1"
                                v-model="date1Formatted"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="dateDay1"
                              @input="dateMenu1 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs6>
                          <v-menu
                            v-model="dateMenu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                class="text2"
                                v-model="date2Formatted"
                                solo
                                dense
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="dateDay2"
                              @input="dateMenu2 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-col>
                  <v-col align="center" cols="10" md="10" v-if="monthClick">
                    <div class="pickers mr-4">
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-menu
                            v-model="monthMenu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                solo
                                dense
                                class="text1"
                                v-model="dateMonth1Formatted"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="dateMonth1"
                              type="month"
                              @input="monthMenu1 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs6>
                          <v-menu
                            v-model="monthMenu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                class="text2"
                                v-model="dateMonth2Formatted"
                                solo
                                dense
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="dateMonth2"
                              type="month"
                              @input="monthMenu2 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-col>
                  <v-col align="center" cols="10" md="10" v-if="yearClick">
                    <div class="pickers mr-4">
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-select
                            v-model="dateYear1"
                            :items="getYears"
                            height="27"
                            solo
                            dense
                          ></v-select>
                        </v-flex>
                        <v-flex xs6>
                          <v-select
                            v-model="dateYear2"
                            :items="getYears"
                            height="27"
                            solo
                            dense
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-col>
                  <v-col md="1"
                    ><v-btn
                      small
                      height="38px"
                      color="#00b0af"
                      @click="emitChange"
                      dark
                      >Go</v-btn
                    ></v-col
                  >
                </v-row>
              </v-col>
              <v-spacer></v-spacer>
              <v-col md="2">
                <v-checkbox
                  v-model="typeStack"
                  :disabled="
                    postType == 'Social' ||
                      postType == 'Sports' ||
                      sportStack == true
                  "
                  color="primary"
                  style="margin-top:-1px;"
                  label="Type Stacked View"
                  @change="emitChange"
                ></v-checkbox>
              </v-col>
              <v-col md="2">
                <v-checkbox
                  v-model="sportStack"
                  :disabled="typeStack"
                  color="primary"
                  label="Sports Stacked View"
                  style="margin-top:-1px;"
                  @change="emitChange"
                ></v-checkbox>
              </v-col>
              <v-col md="2" v-if="typeStack == false && sportStack == false">
                <v-select
                  solo
                  dense
                  :items="['All', 'Sports', 'Social']"
                  label="Type"
                  @change="emitChange"
                >
                </v-select>
              </v-col>
              <v-col md="2" v-if="sportStack == true">
                <v-select
                  solo
                  dense
                  multiple
                  :items="interestSports"
                  v-model="sports"
                  item-value="id"
                  item-text="name"
                  label="Sports"
                  @change="emitChange"
                >
                  <template
                    v-if="interestSports.length == sports.length"
                    v-slot:selection="{ index }"
                  >
                    <span v-if="index == 0">All Sports</span>
                  </template>
                  <template v-else v-slot:selection="{ item, index }">
                    <span v-if="index == 0">{{ item.name }}</span>
                    <span v-if="index == 1">{{ item.name }}</span>
                    <span v-if="index === 2" class="grey--text caption pl-1">
                      and {{ sports.length - 2 }} others</span
                    >
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-container>

          <column-chart
            :data="chartData"
            :dataset="{ borderWidth: 3 }"
            :colors="colors"
            :ytitle="yTitle"
            :xtitle="xTitle"
            :stacked="true"
            :library="chartOptions"
            legend="bottom"
          ></column-chart>
        </v-card>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
//import { mapGetters } from "vuex";

export default {
  props: {
    type: String,
    heading: String,
    chartData: Array,
    yTitle: String,
    xTitle: String,
    clientName: Array,
    hideDateNavigation: { type: Boolean, default: false },
    changeID: { type: Number, default: 0 },
    colors: {
      type: Array,
      default: () => [
        "rgb(44, 59, 70)",
        "rgb(0, 177, 176)",
        "rgb(255, 192, 0)",
        "rgb(123, 127, 129)",
        "rgb(126, 110, 77)",
        "rgb(14, 103, 171)",
        "rgb(109, 139, 163)",
        "rgb(109, 25, 18)",
        "rgb(109, 68, 121)",
        "rgb(56, 68, 121)",
      ],
    },
    heighest: { type: Number },
    filterType: String,
    startDate: String,
    endDate: String,
  },
  data() {
    return {
      toggle_mode: "day",
      typeStack: false,
      sportStack: false,
      dialog: false,
      fullscreenFlag: false,
      fullscreenBtn: true,
      chartOptions: {
        tooltips: { enabled: true },
        legend: {
          labels: {
            filter: function(item) {
              return !item.text.includes("Total");
            },
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                suggestedMax: 2,
              },
            },
          ],
        },
        plugins: {
          datalabels: {
            display: function(context) {
              return context.dataset.data[context.dataIndex] !== 0;
            },
            color: "#fff",
            align: "center",
            anchor: "center",
            font: {
              size: 12,
              weight: 700,
            },
            offset: 8,
          },
        },
      },
      selectedClients: [],
      dateDay1: moment()
        .subtract(10, "days")
        .format("YYYY-MM-DD"),
      dateDay2: moment().format("YYYY-MM-DD"),

      dateMonth1: moment()
        .subtract(6, "months")
        .format("YYYY-MM"),
      dateMonth2: moment().format("YYYY-MM"),

      dateYear1: parseInt(
        moment()
          .subtract(1, "year")
          .format("YYYY")
      ),
      dateYear2: parseInt(moment().format("YYYY")),

      dateMenu1: false,
      dateMenu2: false,
      monthMenu1: false,
      monthMenu2: false,
      dayClick: true,
      monthClick: false,
      yearClick: false,
      postType: null,
      sports: [],
    };
  },
  // created() {
  //   this.sports = this.$store.dispatch("sportsList").then((res) => {
  //     if (res.status == 200) {
  //       this.sports = this.interestSports.map((item) => item.id);
  //     }
  //   });
  // },
  watch: {
    changeID() {
      this.stackType = false;
      this.sportStack = false;
      this.postType = null;
      // this.sports = this.interestSports.map((item) => item.id);
    },
    heighest(val) {
      this.chartOptions.scales.yAxes[0].ticks.suggestedMax = val;
    },
  },
  mounted() {
    this.$store.dispatch("SportsList");
  },
  computed: {
    interestSports() {
      return this.$store.getters.getSports.data;
    },
    getYears() {
      const currentYear = new Date().getFullYear();
      const range = (start, stop, step) =>
        Array.from(
          { length: (stop - start) / step + 1 },
          (_, i) => start + i * step
        );
      return range(currentYear, currentYear - 50, -1);
    },
    date1Formatted() {
      return moment(String(this.dateDay1)).format("DD-MM-YYYY");
    },
    date2Formatted() {
      return moment(String(this.dateDay2)).format("DD-MM-YYYY");
    },
    dateMonth1Formatted() {
      return moment(String(this.dateMonth1)).format("MMM-YYYY");
    },
    dateMonth2Formatted() {
      return moment(String(this.dateMonth2)).format("MMM-YYYY");
    },
  },

  methods: {
    changeMode() {
      if (this.toggle_mode == "day") {
        this.dayClick = true;
        this.monthClick = false;
        this.yearClick = false;
      } else if (this.toggle_mode == "month") {
        this.dayClick = false;
        this.monthClick = true;
        this.yearClick = false;
      } else if (this.toggle_mode == "year") {
        this.dayClick = false;
        this.monthClick = false;
        this.yearClick = true;
      }
      this.emitChange();
    },
    emitBaseChange() {
      let params = { eventType: "all" };
      params.sports = [];
      if (this.typeStack == true) {
        params.stackType = "type";
      } else if (this.sportStack == true) {
        params.stackType = "sports";
        params.sports = this.sports;
      } else {
        params.eventType =
          this.postType == null ? "all" : this.postType.toLowerCase();
        params.stackType = "all";
      }
      params.dateType = this.filterType;
      params.chart = this.type;
      params.startDate = this.startDate;
      params.endDate = this.endDate;
      this.$emit("chartChangeEvent", params);
    },
    emitChange() {
      let params = { eventType: "all" };
      params.sports = [];
      if (this.typeStack == true) {
        params.stackType = "type";
      } else if (this.sportStack == true) {
        params.stackType = "sports";
        params.sports = this.sports;
      } else {
        params.eventType =
          this.postType == null ? "all" : this.postType.toLowerCase();
        params.stackType = "all";
      }
      if (this.toggle_mode == "day") {
        if (
          moment(String(this.dateDay2), "YYYY-MM-DD").diff(
            moment(String(this.dateDay1), "YYYY-MM-DD"),
            "days"
          ) > 30
        ) {
          this.$toast.error("Date range should be less than 31 days", {
            timeout: 10000,
            icon: "mdi-thumb-down",
            dismissable: true,
            showClose: true,
            closeText: "",
            closeIcon: "mdi-close-thick",
            closeColor: "white",
            queueable: true,
          });
          return false;
        }
        params.dateType = "day";
        params.chart = this.type;
        params.startDate = this.dateDay1;
        params.endDate = this.dateDay2;
        this.$emit("chartChangeEvent", params);
      } else if (this.toggle_mode == "month") {
        params.dateType = "month";
        params.chart = this.type;
        params.startDate = this.dateMonth1;
        params.endDate = this.dateMonth2;
        this.$emit("chartChangeEvent", params);
      } else if (this.toggle_mode == "year") {
        params.dateType = "year";
        params.chart = this.type;
        params.startDate = this.dateYear1;
        params.endDate = this.dateYear2;
        this.$emit("chartChangeEvent", params);
      }
    },
    fullscreen() {
      this.dialog = true;
      this.fullscreenFlag = true;
    },
    closeEvent() {
      this.dialog = false;
      this.fullscreenFlag = false;
    },
    // getBaseGraphData() {
    //   let data = [];
    //   if (this.filterType == "day") {
    //     while (moment(end).diff(start, diffUnitOfTime) > 0) {
    //       const currentEnd = moment(
    //         moment(start).add(1, diffUnitOfTime)
    //       ).format("YYYY-MM-DD");

    //       data.push(intervals, { [start]: currentEnd });

    //       start = currentEnd;
    //     }
    //   }
    // },
  },
};
</script>

<style scoped>
.date_button_navigation {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.date_button_navigation .v-item--active {
  background-color: #062b48 !important;
  color: #fff !important;
}
</style>
